import Vue from "vue";
import App from "./App.vue";
import Vuetify from "vuetify";
import Vuelidate from "vuelidate";
import moment from "moment";
import numFormat from "vue-filter-number-format";

import { router } from "./router";

import "@babel/polyfill";
import "./plugins/vuetify";

import "material-design-icons-iconfont/dist/material-design-icons.css";
import titleComponent from './components/customComponents/title.component.vue'

// Use dynamic title
Vue.component('vue-title', titleComponent);

// Initialize vuetify
Vue.use(Vuetify, {
  theme: {
    primary: "#2962FF"
  }
});
Vue.use(Vuetify, {
  iconfont: "mdi"
});

// Initialize vuelidate
Vue.use(Vuelidate);

// Initialize moment for format date
Vue.filter("format-date", function (value) {
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY HH:mm:ss");
  }
});
Vue.filter("format-ms-date-time", function (value) {
  if (value) {
    return moment.unix(value / 1000).format("DD/MM/YYYY hh:mm:ss a");
  }
});
Vue.filter("formatMsDateTime", function(value) {
  if (value) {
    return moment.unix(value / 1000).format("DD/MM/YYYY hh:mm:ss a");
  }
});
Vue.filter("format-ms-date", function (value) {
  if (value) {
    return moment.unix(value / 1000).format("DD/MM/YYYY");
  }
});
Vue.filter("formatMsDate", function(value) {
  if (value) {
    return moment.unix(value / 1000).format("DD/MM/YYYY");
  }
});

Vue.filter('format-ms-custom-date', function (value) {
  if (value) {
    return moment.unix(value / 1000).format("ddd MMMM DD YYYY hh:mm:ss a")
  }
});

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY')
  }
});

Vue.filter('formatmonth', function (value) {
  if (value) {
    return moment(String(value)).format('MMMM/YYYY')
  }
});

Vue.filter('format-year', function(value){
  if (value) {
    return moment(String(value)).format('YYYY')
  }
});

Vue.filter('format-month', function(value){
  if (value) {
    return moment(String(value)).format('YYYY-MM')
  }
});

// Initialize number format
Vue.filter("numFormat", numFormat);

//default v is 2( decFormat -> 2 Decimal)
Vue.filter('decFormat', function (value,v) {
  let decPlace =2;
  if(typeof v != 'undefined'){
    decPlace = v;
  }
  if (!value){ 
    value = 0;
    return value.toFixed(decPlace).toString();
  }
  else return parseFloat(value).toFixed(decPlace).toString().replace(/\B(?<!(\.\d*|^.{0}))(?=(\d{3})+(?!\d))/g, ',');
});

Vue.filter('fourDecFormat', function (value,  v) {
  let decPlace =4;
  if(typeof v != 'undefined'){
    decPlace = v;
  }
  if (!value){ 
    value = 0;
    return value.toFixed(decPlace).toString();
  }
  else return parseFloat(value).toFixed(decPlace).toString().replace(/\B(?<!(\.\d*|^.{0}))(?=(\d{3})+(?!\d))/g, ',');
});

Vue.config.productionTip = false;
new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
